module.exports = __webpack_public_path__ + "img/logo-no-bg.a26ebdf9.svg";